import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';

const propTypes = {
  unitPrice: PropTypes.number.isRequired,
  quantity: PropTypes.number,
  className: PropTypes.string,
  append: PropTypes.string,
  prepend: PropTypes.string,
};

const defaultProps = {
  quantity: 1,
  className: '',
  append: '',
  prepend: '',
};

const FormattedPrice = props => {
  const total = props.unitPrice * props.quantity;
  const format = total % 1 === 0 ? '$0,0' : '$0,0.00';
  const price = numeral(total).format(format);

  return (
    <span className={props.className}>
      {props.prepend}
      {price}
      {props.append}
    </span>
  );
};

FormattedPrice.propTypes = propTypes;

FormattedPrice.defaultProps = defaultProps;

export default FormattedPrice;



// WEBPACK FOOTER //
// ./src/components/shared/FormattedPrice/FormattedPrice.jsx